import {
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { CvaTouchedService } from '../../model/cva-touched.service';

@Component({
  selector: 'core-form-footer',
  templateUrl: './form-footer.component.html',
  styleUrls: ['./form-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FormFooterComponent {
  @Input() stepper: MatStepper;
  @Input() isEditMode: boolean;
  @Input() isReadonly: boolean;
  @Input() submitting = false;
  @Output() canceled = new EventEmitter<void>();
  @Input() submitButtonText: string;

  private readonly cvaTouchedService = inject(CvaTouchedService);

  onCancelClick(): void {
    this.canceled.emit();
  }

  goToPrevious(): void {
    this.stepper.previous();
  }

  goToNext(): void {
    const stepControl = this.stepper.selected.stepControl;
    if (stepControl instanceof AbstractControl) {
      this.cvaTouchedService.markAllAsTouched(stepControl);
    }
    this.stepper.next();
  }
}
